import { render, staticRenderFns } from "./SystemDetails.vue?vue&type=template&id=6c918ce4&scoped=true"
import script from "./SystemDetails.vue?vue&type=script&lang=js"
export * from "./SystemDetails.vue?vue&type=script&lang=js"
import style0 from "./SystemDetails.vue?vue&type=style&index=0&id=6c918ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c918ce4",
  null
  
)

export default component.exports